import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "../contexts/AuthContext"; 
import { Provider } from 'react-redux';
import store from './components/redux'; 
import "./index.css";

const rootElement = document.getElementById("root");

ReactDOM.createRoot(rootElement).render(
  <AuthProvider>
    <Provider store={store}>  
      <App />
    </Provider>
  </AuthProvider> 
);